module.exports = __webpack_public_path__ + "static/media/jghero.db4981eb.png";